export default __webpack_public_path__ + "static/media/correio.01ee130c.svg";